module.exports = __webpack_public_path__ + "img/BS.bb311b4d.svg";